(() => {
  'use strict';

  const DRAWER_ID = 'MinimogCartDrawer';
  const BOTTOM_TOLERANCE = 24;
  const TOP_CUE_LIMIT = 28;
  const MIN_OVERFLOW = 20;

  function initialiseCartScrollCue() {
    const drawer = document.getElementById(DRAWER_ID);
    if (!drawer || drawer.dataset.frkScrollReady === 'true') return;

    const shell = drawer.querySelector('[data-frk-cart-scroll-shell]');
    const body = drawer.querySelector('[data-frk-cart-scroll-body]');
    const cue = drawer.querySelector('[data-frk-cart-scroll-cue]');
    const button = drawer.querySelector('[data-frk-cart-scroll-button]');

    if (!shell || !body || !cue || !button) return;
    drawer.dataset.frkScrollReady = 'true';

    let frame = 0;

    const update = () => {
      frame = 0;

      const maximumScroll = Math.max(0, body.scrollHeight - body.clientHeight);
      const hasOverflow = maximumScroll > MIN_OVERFLOW;
      const isNearTop = body.scrollTop <= TOP_CUE_LIMIT;
      const isNearBottom = body.scrollTop >= maximumScroll - BOTTOM_TOLERANCE;
      const hasCartItems = Boolean(body.querySelector('[data-cart-item]'));
      const showCue = hasCartItems && hasOverflow && isNearTop && !isNearBottom;

      shell.classList.toggle('frk-cart-scroll-shell--scrollable', hasOverflow);
      shell.classList.toggle('frk-cart-scroll-shell--scrolled', body.scrollTop > 6);
      shell.classList.toggle('frk-cart-scroll-shell--at-bottom', hasOverflow && isNearBottom);

      cue.hidden = !showCue;
      cue.setAttribute('aria-hidden', showCue ? 'false' : 'true');
    };

    const scheduleUpdate = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(update);
    };

    button.addEventListener('click', () => {
      const distance = Math.max(240, Math.round(body.clientHeight * 0.68));
      const prefersReducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
      body.scrollBy({ top: distance, behavior: prefersReducedMotion ? 'auto' : 'smooth' });
      try {
        body.focus({ preventScroll: true });
      } catch (error) {
        body.focus();
      }
    });

    body.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate, { passive: true });
    window.addEventListener('pageshow', scheduleUpdate);
    document.addEventListener('cart:updated', scheduleUpdate);
    document.addEventListener('cart:refresh', () => window.setTimeout(scheduleUpdate, 80));

    const contentObserver = new MutationObserver(() => {
      window.setTimeout(scheduleUpdate, 30);
    });
    contentObserver.observe(body, { childList: true, subtree: true });

    const drawerObserver = new MutationObserver(() => {
      scheduleUpdate();
      window.setTimeout(scheduleUpdate, 340);
    });
    drawerObserver.observe(drawer, {
      attributes: true,
      attributeFilter: ['class', 'style']
    });

    if ('ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver(scheduleUpdate);
      resizeObserver.observe(body);
      resizeObserver.observe(shell);
    }

    scheduleUpdate();
    window.setTimeout(scheduleUpdate, 120);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseCartScrollCue, { once: true });
  } else {
    initialiseCartScrollCue();
  }
})();
